import React, { Component } from 'react';
import { connect } from 'react-redux';
import { getVerificationJson } from '@/services/Andes_v2/results'
import { getWaveformResult, getPowerSumResultList } from '@/services/Andes_v2/results/waveform';
import PowerSum from '@/components/powerSum';
import { getReportConfig, saveReportConfig, updateReportInfo } from '../../store/project/action';
import { generateTDRSBRResult, getTDRSBRSettingData } from '../../../../services/Andes_v2/results/resultCtrl';
import { ANDES_V2 } from '../../../../constants/pageType';
import Setting from '../../../../services/Andes_v2/results/waveform/TDRSBRSetting';
import TxAndRxPortSetting from '../Sparameter/TxAndRxPortSetting';
import { saveReportConfigPromise } from '../../../../services/Andes_v2/channel';
import { getPowerSumResultObject, initSignalPortsByPowerSum } from '../../../../services/Andes_v2/results/sparameter/dataHelper';
import { getPCBIndexMap } from '../../../../services/Andes_v2/results/sparameter/endToEnd';

class PowerSumResult extends Component {
  constructor(props) {
    super(props);
    this.state = {
      portSettingVisible: false,
      changeEnable: false
    }
  }

  changeRxCentricMode = async (key, value, interfaceContent) => {
    const { id, projectId, reportConfig, rxCentricMode, isEndToEnd } = this.props;
    const newReportConfig = {
      ...reportConfig,
      custom: {
        ...reportConfig.custom,
        rxCentricMode: {
          ...rxCentricMode,
          [key]: value
        }
      }
    }

    // If filtering mode is enabled for the first time, the data must also be initialized
    if (!rxCentricMode.signalPorts && key === 'enable') {
      newReportConfig.custom.rxCentricMode.signalPorts = initSignalPortsByPowerSum(interfaceContent, isEndToEnd);
    }

    await saveReportConfigPromise({ projectId, channelId: id, config: newReportConfig });
    this.props._updateReportInfo({ reportConfig: newReportConfig });

    if (key === 'enable') {
      // No recalculation is performed when port view is opened,
      // and the open status is recorded. When popup window is closed, 
      // recalculation is performed regardless of whether SignalPorts is modified
      if (value) {
        this.PowerSum.updatePortSettingVisible(true);
        this.setState({ changeEnable: true });
      } else {
        this.PowerSum.powerSumSettingRecalculate();
      }
    }
  }

  updateIsRecalculate = async (isRecalculate) => {
    const { reportConfig, rxCentricMode, projectId, id } = this.props;
    const newReportConfig = {
      ...reportConfig,
      custom: {
        ...reportConfig.custom,
        rxCentricMode: {
          ...rxCentricMode,
          isRecalculate
        }
      }
    }
    // save config to server
    await saveReportConfigPromise({ projectId, channelId: id, config: newReportConfig });
    // save config to store
    this.props._updateReportInfo({ reportConfig: newReportConfig });
  }

  closeTxAndRxPortSetting = (isRecalculate) => {
    const { changeEnable } = this.state;
    this.PowerSum.updatePortSettingVisible(false, isRecalculate || changeEnable);
    if (changeEnable) {
      this.setState({ changeEnable: false });
    }
  }

  TxAndRxPortSetting = (interfaceContent) => {
    if (!interfaceContent) return;
    const { rxCentricMode, isEndToEnd } = this.props;
    const components = interfaceContent && interfaceContent.content ? interfaceContent.content.components || [] : [];
    const pcbIndexMap = isEndToEnd && interfaceContent.endToEnd && interfaceContent.endToEnd.content
      ? getPCBIndexMap(interfaceContent.endToEnd.content.pcbConnections) : null;

    return <TxAndRxPortSetting
      closePanel={this.closeTxAndRxPortSetting}
      signalPorts={rxCentricMode.signalPorts}
      components={components}
      changeRxCentricMode={(key, value) => this.changeRxCentricMode(key, value, interfaceContent)}
      isEndToEnd={isEndToEnd}
      pcbIndexMap={pcbIndexMap}
      interfaceContent={interfaceContent}
    />
  }

  render() {
    const { reportConfig, id, channelId, resultPageType, isEndToEnd } = this.props;
    return <PowerSum
      {...this.props}
      id={id}
      channelId={channelId}
      isEndToEnd={isEndToEnd}
      resultPageType={resultPageType}
      getVerificationJson={getVerificationJson}
      getWaveformResult={getWaveformResult}
      reportConfig={reportConfig || {}}
      generateTDRSBRResult={generateTDRSBRResult}
      getTDRSBRSettingData={getTDRSBRSettingData}
      getPowerSumResultList={getPowerSumResultList}
      pageType={ANDES_V2}
      Setting={Setting}
      ref={(ref) => { this.PowerSum = ref }}
      TxAndRxPortSetting={this.TxAndRxPortSetting}
      getResultObject={getPowerSumResultObject}
      changeRxCentricMode={this.changeRxCentricMode}
      updateIsRecalculate={this.updateIsRecalculate}
    />
  }
}


const mapState = (state) => {
  const { AndesV2Reducer: { project: { openProjectId, reportInfo } } } = state;
  const { reportConfig = {}, reportConfigLoading } = reportInfo || {};
  const rxCentricMode = reportConfig.custom && reportConfig.custom.rxCentricMode ? reportConfig.custom.rxCentricMode : {};
  return {
    projectId: openProjectId,
    reportConfig,
    reportConfigLoading,
    rxCentricMode
  };
}

const mapDispatch = (dispatch) => ({
  _updateReportInfo(info) {
    dispatch(updateReportInfo(info))
  },
  _saveReportConfig(channelId, isMultiPCB) {
    dispatch(saveReportConfig(channelId, isMultiPCB))
  },
  _getReportConfig({ channelId, projectId, endToEndChannelId, isEndToEnd, dataRate, interfaceType }) {
    dispatch(getReportConfig({ channelId, projectId, endToEndChannelId, isEndToEnd, dataRate, interfaceType }))
  }
})

export default connect(mapState, mapDispatch)(PowerSumResult);